import React, { useEffect, useRef, useState } from 'react'
import styled from './index.module.css'
import HospitalInformation from './HospitalInformation'
import { BASEURL } from '../../config'
import Naver from '../../img/naver.png'
import Toggle from '../../components/ToggleSwitch'
import HospitalOpinion from './HospitalOpinion'
import SendOpinionPopup from '../../components/SendOpinionPopup'
import ReviewListPopup from '../../components/ReviewListPopup'
import axios from 'axios'
import useAccountStore from '../../stores/account'

const SettingPage = () => {
    const {accessToken} = useAccountStore()
    const [showSendOpinionPopup, setShowSendOpinionPopup] = useState(false)
    const [showReviewListPopup, setShowReviewListPopup] = useState(false)
    const [reviewList, setReviewList] = useState<any[]>([])
    const popRef = useRef<HTMLDivElement>(null)
    const popRef2 = useRef<HTMLDivElement>(null)

    const ReviewConfirmation = () => {
        const [reviewPassword, setReviewPassword] = useState<string>('')

        const reviewPasswordhandler = (e: React.ChangeEvent<HTMLInputElement>) => {
            setReviewPassword(e.target.value)
        }

        const showReviews = async() => {
            const isConfirm = await axios.put(`${BASEURL}/review/verify`, 
                { password: reviewPassword }, 
                { headers: { Authorization: `Bearer ${accessToken}` } }
            ).then(response => response.data).catch(error => { return {status: "error"} })

            if(isConfirm.status === "success") {
                setShowReviewListPopup(true)
                getReviews()
            }  else alert("비밀번호가 틀렸습니다")
        }

        const getReviews = () => {
            axios.get(`${BASEURL}/review/list`, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(obj => {
                if(obj.status === "success") { 
                    setReviewList(obj.data) 
                }
            }).catch(error => {
                setReviewList([])

                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })  
        }

        
        return (<>
            <div className={styled.container}>
                <div className={styled.show_review}>
                    <div className={styled.top}>
                        <span className={styled.tit}>후기 확인</span>
                    </div>
                
                    <div className={styled.rv_password}>
                        <p> 비밀번호 입력</p>
                        <input type="password" value={reviewPassword} onChange={reviewPasswordhandler} placeholder='비밀번호를 입력하세요'/>
                        <button onClick={showReviews}>보기</button>
                    </div>
                </div>
            </div>
           <ReviewListPopup popRef={popRef2}
           reviewList={reviewList}
           showReviewListPopup={showReviewListPopup}
           setReviewListPopup={setShowReviewListPopup}/>
           </>
        )
    }

    const ReservationConn = () => {
        const [isConn, setConn] = useState<boolean>(false)
        const toggleConn = () => { setConn(!isConn)}
        return (
             <div className={styled.container}>
             <div className={styled.rsv_conn}>
                 <div className={styled.top}>
                     <span className={styled.tit}>예약 연동</span>
                 </div> 
                 <div className={styled.channel}>
                     <div className={styled.tit}><img src={Naver} alt="icon"/><p>네이버 예약</p></div>
                     <input type="text" placeholder='API Key 입력'/>
                     <div className={styled.toggle}>
                        <p className={isConn ? styled.use : styled.notuse}>{isConn ? "연동중" : "미연동"}</p>
                        <Toggle isOn={isConn} toggleSwitch= {toggleConn}/>
                     </div>
                 </div>
             </div>
       </div>
        )
    }

    return (
        <>
        <div className="contents">
         <div className={styled.settings}>
            {/** 왼쪽 */}
            <div style={{padding:'10px 15px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
                {/** 병원 정보*/}
                <HospitalInformation/>
                <ReviewConfirmation/>
                {/* <ReservationConn/> */}
            </div>

            {/** 오른쪽 */}
            <div style={{padding:'10px 15px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <HospitalOpinion/>
            </div>
         </div>
     </div>
        <SendOpinionPopup popRef={popRef}
            showSendOpinionPopup={showSendOpinionPopup}
            setSendOpinionPopup={setShowSendOpinionPopup}/>
        </>
    )
}

export default SettingPage
